import { environment } from "./../../environments/environment";

let baseUrl: string = environment.baseUrl;

export class Url {
  static workshop: string = baseUrl + "workShops";
  static stock: string = baseUrl + "stocks";
  static powertrain: string = baseUrl + "powertrains";
  static sparepart: string = baseUrl + "spareparts";
  static troubleshooting: string = baseUrl + "troubleshootings";
  static troubleshootingqa: string = baseUrl + "troubleshootingqas";
  static troubleshootingqabox: string = baseUrl + "troubleshootingqaboxes";
  static engine: string = baseUrl + "motors";
  static setting: string = baseUrl + "settings";
  static catalog: string = baseUrl + "catalogs";
  static user: string = baseUrl + "accounts";
  static action: string = baseUrl + "actions";
  static visit: string = baseUrl + "visits";
  static qavisit: string = baseUrl + "qavisits";
  static qavisitpoint: string = baseUrl + "qavisitpoints";
  static sparepartsinout: string = baseUrl + "sparepartsinouts";
}
